import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { APP_LAYOUT_ROUTES } from '../app/routes';
import PageWrapper from '../app/components/PageWrapper';
import PageNavigation from '../app/components/PageNavigation';
import { user } from '../account/api/accountSlice';
import { createSettingsRoutes } from './routes';

const Settings: FunctionComponent = () => {
  const patient = useSelector(user);
  const isHouseholdMember = patient?.headOfHousehold != null;
  const settingsRoutes = createSettingsRoutes(isHouseholdMember);

  return (
    <PageWrapper title={APP_LAYOUT_ROUTES.SETTINGS.title}>
      <PageNavigation routes={settingsRoutes} />
      <div style={{ padding: '32px' }}>
        <Outlet />
      </div>
    </PageWrapper>
  );
};

export default Settings;
